// extracted by css-extract-rspack-plugin
module.exports =  {"description":"Description__description--Bu_k4","caution":"Description__caution--Pnq46"};